/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import StatusStepHeader from '../statusStepHeader';
import BackIcon from '../images/caret-left-black.svg';

const timezone = new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];

function tomorrowAt(hour, format = 'readable') {
  const date = new Date();
  date.setDate(date.getDate() + 1);
  date.setHours(hour, 0, 0, 0);

  if (format === 'readable') {
    return [
      new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date),
      `${date.getDate()},`,
      `${hour % 12}:00 ${hour > 12 ? 'PM' : 'AM'}`,
    ].join(' ');
  }

  return date.getTime();
}

const scrollToBottom = () => {
  const bottomScrollAnchor = document.getElementById('reminder-options');

  if (bottomScrollAnchor) {
    setTimeout(() => {
      bottomScrollAnchor.scrollIntoView({
        block: 'start',
        inline: 'nearest',
        behavior: 'smooth',
      });
    }, 200);
  }
};

const StepThree = (props) => {
  const {
    state: {
      reminderOption,
      reminderDate,
      reminderHour,
      reminderMinutes,
      reminderAmPm,
    },
    handleDateBlur,
    buildDate,
    updateState,
    collapsible,
  } = props;

  const [collapsed, setCollapsed] = useState(true);

  const handleReminder = (e) => {
    const { value } = e.currentTarget;

    const newState = {
      reminder_attributes: {},
    };

    if (value !== reminderOption) {
      newState.reminderOption = value;

      if (value === 'tomorrowMorning') {
        newState.reminder_attributes.alert_datetime = tomorrowAt(8, 'epoch');
      } else if (value === 'tomorrowAfternoon') {
        newState.reminder_attributes.alert_datetime = tomorrowAt(13, 'epoch');
      } else {
        const tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);

        newState.reminderDate = [
          tomorrow.getFullYear(),
          String(tomorrow.getMonth() + 1).padStart(2, '0'),
          String(tomorrow.getDate()).padStart(2, '0'),
        ].join('-');

        newState.reminderHour = tomorrow.getHours() % 12 || 12;
        newState.reminderMinutes = ((Math.round(tomorrow.getMinutes() / 15) * 15) % 60)
          .toString()
          .padStart(2, '0');
        newState.reminderAmPm = tomorrow.getHours() >= 12 ? 'PM' : 'AM';
        newState.reminder_attributes.alert_datetime = tomorrow.getTime();
      }
    } else {
      newState.reminderOption = '';
    }

    updateState(newState);

    if (value === 'pickADate') {
      scrollToBottom();
    }
  };

  const handleDatetimeChange = (e) => {
    const { name, value } = e.target;
    const newState = { [name]: value };

    updateState(newState, buildDate);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);

    if (collapsed) {
      scrollToBottom();
    }
  };

  const header = () => {
    const arrowClassList = ['options-arrow'];

    if (collapsed) {
      arrowClassList.push('selected');
    }

    if (collapsible) {
      return (
        <div className="action-headline">
          <button
            type="button"
            className="collapse-button"
            onClick={toggleCollapsed}
          >
            <StatusStepHeader
              step="3"
              stepComplete={reminderOption.length > 0}
            >
              <div className="schedule-container">
                <span className="schedule">Schedule text reminder (optional)</span>
                <span className="timezone">{timezone}</span>
              </div>
            </StatusStepHeader>
            <img
              alt=""
              className={arrowClassList.join(' ')}
              src={BackIcon}
            />
          </button>
        </div>
      );
    }

    return (
      <div className="action-headline">
        <StatusStepHeader
          step="3"
          stepComplete={reminderOption.length > 0}
        >
          <div className="schedule-container">
            <span className="schedule">Schedule text reminder (optional)</span>
            <span className="timezone">{timezone}</span>
          </div>
        </StatusStepHeader>
      </div>
    );
  };

  const bodyClassList = ['notify-loop-action-body'];

  if (collapsed) {
    bodyClassList.push('collapsed');
  }

  return (
    <div className="step-3">
      <div className={bodyClassList.join(' ')}>
        {header()}
        <div
          id="reminder-options"
          className="action-details large-slim-font"
        >
          <button
            type="button"
            className={
              reminderOption === 'tomorrowMorning'
                ? 'reminder-button selected'
                : 'reminder-button'
            }
            value="tomorrowMorning"
            onClick={handleReminder}
          >
            <div className="reminder-button-inner">
              <span>Tomorrow morning</span>
              <span>{tomorrowAt(8)}</span>
            </div>
          </button>
          <button
            type="button"
            className={
              reminderOption === 'tomorrowAfternoon'
                ? 'reminder-button selected'
                : 'reminder-button'
            }
            value="tomorrowAfternoon"
            onClick={handleReminder}
          >
            <div className="reminder-button-inner">
              <span>Tomorrow afternoon</span>
              <span>{tomorrowAt(13)}</span>
            </div>
          </button>
          <button
            id="reminder-selector"
            type="button"
            className={
              reminderOption === 'pickADate'
                ? 'reminder-button selected'
                : 'reminder-button'
            }
            value="pickADate"
            onClick={handleReminder}
          >
            <i className="datepicker" />
            Pick date & time
          </button>
          {
            reminderOption === 'pickADate' && (
              <div className="datetime-container">
                <input
                  min="2021-11-05"
                  name="reminderDate"
                  onBlur={handleDateBlur}
                  onChange={handleDatetimeChange}
                  pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
                  placeholder="Select date"
                  type="date"
                  value={reminderDate}
                />
                <div className="select-wrapper">
                  <select
                    name="reminderHour"
                    value={reminderHour}
                    onChange={handleDatetimeChange}
                  >
                    <option value="">--</option>
                    {
                      [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((opt, idx) => (
                        <option key={idx} value={opt}>{opt}</option>
                      ))
                    }
                  </select>
                </div>
                <div className="select-wrapper">
                  <select
                    name="reminderMinutes"
                    value={reminderMinutes}
                    onChange={handleDatetimeChange}
                  >
                    <option value="">--</option>
                    {
                      ['00', '15', '30', '45'].map((opt, idx) => (
                        <option key={idx} value={opt}>{opt}</option>
                      ))
                    }
                  </select>
                </div>
                <div className="select-wrapper">
                  <select
                    name="reminderAmPm"
                    value={reminderAmPm}
                    onChange={handleDatetimeChange}
                  >
                    {
                      ['AM', 'PM'].map((opt, idx) => (
                        <option key={idx} value={opt}>{opt}</option>
                      ))
                    }
                  </select>
                </div>
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default StepThree;

StepThree.defaulProps = {
  collapsible: false,
};
